import { render, staticRenderFns } from "./DesignOpposition.vue?vue&type=template&id=1b1b56d5&"
import script from "./DesignOpposition.vue?vue&type=script&lang=js&"
export * from "./DesignOpposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports